module.exports = __webpack_public_path__ + "static/media/logo_seriea.cba74588.png";